const statusBadge = (status) => {
    if (status == null || status === '') {
        return <span className="text-muted">—</span>;
    }
    const isActive = status === 'Active';
    return (
        <span
            className={`badge rounded-pill px-2 py-1 d-inline-flex align-items-center gap-2 ${isActive ? 'table-sb-active' : 'table-sb-inactive'} text-uppercase`}
        >
            <span className={`dot-icon rounded-circle ${isActive ? 'dot-icon-active' : 'dot-icon-inactive'}`} />
            {status}
        </span>
    );
};

export default statusBadge;